import { FaStar, FaCompass } from "react-icons/fa";
import { travelPassions } from "../../data/dummyData";

const TravelPassion = () => {
  return (
    <div className="pt-12 md:pt-20 pb-16 md:pb-28 bg-gradient-to-b from-white via-cyan-50/30 to-white dark:from-gray-900 dark:via-gray-800/50 dark:to-gray-900">
      <div className="text-center mb-8 md:mb-12 px-4">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold bg-gradient-to-r from-blue-600 to-cyan-600 bg-clip-text text-transparent mb-3 md:mb-4 flex items-center justify-center gap-2 md:gap-3">
          <FaCompass className="text-blue-600 text-2xl sm:text-3xl md:text-4xl" />
          <span>Discover Albania's Beauty</span>
        </h1>
        <p className="text-gray-600 dark:text-gray-300 text-sm sm:text-base md:text-lg max-w-2xl mx-auto mt-3 md:mt-4 leading-relaxed px-2">
          From stunning beaches to hidden caves, Albania offers unforgettable
          water experiences
        </p>
      </div>
      <div className="mt-8 md:mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5 md:gap-6 max-w-7xl mx-auto px-4 sm:px-6">
        {travelPassions.map(
          ({ id, name, image, number_of_reviews, rating }) => (
            <div
              className="group rounded-2xl overflow-hidden relative flex-1 basis-[16rem] shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border-2 border-transparent hover:border-cyan-400 dark:hover:border-cyan-600 cursor-pointer"
              key={id}
            >
              <div className="relative overflow-hidden h-[280px] sm:h-[320px] md:h-[350px]">
                <img
                  src={image}
                  alt={name}
                  className="w-full h-full object-cover group-hover:scale-110 group-hover:brightness-110 transition-all duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-5 md:p-6 text-white">
                <h1 className="font-bold text-lg sm:text-xl md:text-2xl mb-2 group-hover:text-cyan-300 transition">
                  {name}
                </h1>
                <div className="flex items-center gap-x-2 bg-white/10 backdrop-blur-sm w-fit px-2.5 sm:px-3 py-1.5 rounded-full">
                  <FaStar className="text-yellow-400 text-sm" />
                  <p className="text-xs sm:text-sm font-semibold">
                    {rating}
                    <span className="opacity-80 ml-1 text-xs">
                      ({number_of_reviews} reviews)
                    </span>
                  </p>
                </div>
              </div>
            </div>
          ),
        )}
      </div>
    </div>
  );
};

export default TravelPassion;
